import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../../components/CustomButton";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../helpers/apiHelper";
import useRoutesHelper from "../../../../hooks/useRoutesHelper";
import { postFinalizeLabeledProductsReceipt } from "../../../../redux/api/receipt.api";
import { useAppDispatch } from "../../../../redux/hooks";
import Text from "../../../../styleguide/Text";

function LabeledProductsHeader() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { routeParams } = useRoutesHelper();
  const [isLoading, setIsLoading] = useState(false);

  const receptionId = routeParams?.reception;
  const provider = routeParams?.furnizor;
  const receivedAt = routeParams?.data;

  const handleFinalizeReception = async () => {
    if (!receptionId) return;

    setIsLoading(true);

    const resultAction = await dispatch(
      postFinalizeLabeledProductsReceipt({
        idFluxReceptie: receptionId,
      }),
    );

    if (
      checkEndpointStatus(resultAction, postFinalizeLabeledProductsReceipt) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, postFinalizeLabeledProductsReceipt) ===
      endpointStatus.fulfilled
    ) {
      navigate(-1);
    }
  };

  const tableTitle = `Situatia etichetarii pentru produsele primite${
    provider ? ` de la ${provider}` : ""
  }${receivedAt ? ` in data ${receivedAt}` : ""}`;

  const confirmationMessage = `Confirmati faptul ca a fost etichetata toata cantitatea de produse primite de la ${
    provider ?? "-"
  } in data ${receivedAt ?? "-"}?`;

  return (
    <div className="flex justify-between items-center mb-6">
      <Text
        variant="h3"
        component="h3"
        className="font-semibold text-slate-900 mb-4"
        gutterBottom>
        {tableTitle}
      </Text>

      <CustomButton
        variant="contained"
        loading={isLoading}
        disabled={!receptionId || isLoading}
        withConfirmationModal={{
          modalTitle: "Finalizare receptie",
          modalSubtitle: confirmationMessage,
          modalLeftButtonText: "Nu",
          modalRightButtonText: "Da",
          modalLeftButtonVariant: "outlined",
          modalRightButtonVariant: "contained",
          modalRightButtonColor: "primary",
          modalRightButtonOnClick: handleFinalizeReception,
          modalSize: "lg",
        }}>
        Finalizare receptie
      </CustomButton>
    </div>
  );
}

export default LabeledProductsHeader;
